export const INDEX = "/";
export const SIGNIN = "/signin";
export const SIGNUP = "/signup";

export const ACCOUNT = "/account";
export const KHATA = "/khata";